// extracted by mini-css-extract-plugin
export var closeButton = "_dt-1";
export var closeX = "_dt-3";
export var container = "_dt-0";
export var image = "_dt-2";